export function checkRequired(date) {
  let now = new Date().getTime();
  let target = new Date(date).getTime();
  if (now > target) return true;
  else return false;
}
